import React, { useRef, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
const IoArrowBack = require("react-icons/io5").IoArrowBack;

const kategoriWebOptions = ["Peduli Sumatera", "Peduli Sudan", "Peduli Palestina", "Peduli Yatim", "Peduli Lansia"];

const TambahNews = () => {
  const [judul, setJudul] = useState("");
  const [kategori, setKategori] = useState("");
  const [kategoriWeb, setKategoriWeb] = useState("");
  const [deskripsi, setDeskripsi] = useState("");
  const [gambar, setGambar] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);

  const quillRef = useRef<ReactQuill | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("judul", judul);
    formData.append("kategori", kategori);
    formData.append("kategori_web", kategoriWeb);
    formData.append("deskripsi", deskripsi);
    if (gambar) formData.append("gambar", gambar);

    const token = document.cookie
      .split("; ")
      .find((row) => row.startsWith("token="))
      ?.split("=")[1];

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/berita`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      alert("Berita berhasil ditambahkan");
      navigate("/dashboard/news");
    } catch (err) {
      console.error(err);
      alert("Gagal menambahkan berita");
    } finally {
      setLoading(false);
    }
  };

  const modules = {
    toolbar: [[{ header: [1, 2, false] }], ["bold", "italic", "underline", "strike"], [{ list: "ordered" }, { list: "bullet" }], ["clean"]],
  };

  const formats = ["header", "bold", "italic", "underline", "strike", "list", "bullet"];

  const isFormValid = judul && kategori && kategoriWeb && deskripsi && gambar;

  return (
    <div className="max-w-3xl mx-auto mt-10 p-6 bg-white rounded shadow">
      <Link to="/dashboard/news">
        <div className="flex items-center gap-3 mb-4 text-orange-600">
          <IoArrowBack />
          <h1 className="text-xl font-bold">Tambah Berita</h1>
        </div>
      </Link>

      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Judul */}
        <div>
          <label className="font-semibold">Judul</label>
          <input type="text" className="w-full border px-3 py-2 rounded" value={judul} onChange={(e) => setJudul(e.target.value)} />
        </div>

        {/* Kategori */}
        <div>
          <label className="font-semibold">Kategori</label>
          <input type="text" className="w-full border px-3 py-2 rounded" placeholder="Nasional / Internasional" value={kategori} onChange={(e) => setKategori(e.target.value)} />
        </div>

        {/* Kategori Web */}
        <div>
          <label className="font-semibold">Kategori Web</label>
          <select className="w-full border px-3 py-2 rounded bg-white" value={kategoriWeb} onChange={(e) => setKategoriWeb(e.target.value)}>
            <option value="">-- Pilih Kategori Web --</option>
            {kategoriWebOptions.map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>

        {/* Deskripsi */}
        <div>
          <label className="font-semibold mb-1 block">Deskripsi</label>
          <ReactQuill ref={quillRef} theme="snow" value={deskripsi} onChange={setDeskripsi} modules={modules} formats={formats} />
        </div>

        {/* Gambar */}
        <div>
          <label className="font-semibold">Gambar</label>
          <input type="file" className="w-full border px-3 py-2 rounded bg-white" onChange={(e) => setGambar(e.target.files?.[0] || null)} />
        </div>

        {/* Submit */}
        <button type="submit" disabled={!isFormValid || loading} className={`w-full py-2 rounded text-white ${isFormValid ? "bg-orange-600 hover:bg-orange-700" : "bg-gray-400 cursor-not-allowed"}`}>
          {loading ? "Mengirim..." : "Tambah Berita"}
        </button>
      </form>
    </div>
  );
};

export default TambahNews;
